import { BaseModel } from '@shared/base/Base.Model';
import { IWebSocketModel } from '@shared/interface/IWebSocketModel';
import { WebSocketModelUtility } from '@shared/utility/WebSocketModel.Utility';

export interface IConnectedToolsCountModel {
    numTools: number;
}

export class ConnectedToolsCountModel extends BaseModel implements IConnectedToolsCountModel, IWebSocketModel {
    public static readonly expectedPacketType: string = 'connected_tools_count';

    public isIWebSocketModel: boolean = true;
    public packetType: string = null;
    public id: number = null;

    public numTools: number = null;

    public constructor() {
        super();
    }

    public loadFromWebSocketMessage(message: any): void {
        WebSocketModelUtility.loadProperties(message, this, 'RIFT-WS-ConnectedToolsCountModel');
    }

    public toWebSocketMessage(): any {
        return {
            ...WebSocketModelUtility.toJson(this),
        };
    }
}
